module.exports = __webpack_public_path__ + "static/media/accounts_vendors_add.b677b5d5.svg";